<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('tuevs.time.form.fields.codigo.label')" label-for="input-codigo">
          <b-form-input id="input-codigo" v-model="time.code" type="text"/>
        </b-form-group>
        <b-form-group :label="$t('tuevs.time.form.fields.nome.label')" label-for="input-name">
          <b-form-input id="input-name" v-model="time.name" type="text"/>
        </b-form-group>

        <b-form-group
            :label="$t('tuevs.time.form.fields.status.label')"
            label-for="input-status"
            :description="$t('tuevs.time.form.fields.status.description')"
        >
          <b-form-checkbox id="input-status" v-model="time.status" size="lg" switch/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('tuevs.time.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import TimeRepository from '@/repositories/tuevs/TimeRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient
  },
  data() {
    return {
      time_id: null
    }
  },
  computed: {
    ...mapGetters({
      time: 'tuevs/time/current',
      isLoading: 'tuevs/time/isLoading'
    }),
    pageTitle() {
      if (this.time_id) return this.$t('tuevs.time.form.titulo_pagina.editar')
      return this.$t('tuevs.time.form.titulo_pagina.criar')
    }
  },
  async mounted() {
    this.$store.commit('tuevs/time/setCurrent', {status: false})
    if (this.$route.params.id) {
      this.time_id = this.$route.params.id
      await this['tuevs/time/listOne'](this.$route.params.id)
    }
  },
  methods: {
    ...mapActions([
      'tuevs/time/listOne'
    ]),
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      TimeRepository.post(this.time).then(() => {
        this.$snotify.success(this.$t('tuevs.time.form.create.success'))
        this.$router.push({name: 'tuevs.time'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.time.form.create.error'))
        if (error.response.status === 422) {
          TimeRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      TimeRepository.put(this.time_id, this.time).then(() => {
        this.$snotify.success(this.$t('tuevs.time.form.update.success'))
        this.$router.push({name: 'tuevs.time'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.time.form.update.error'))
        if (error.response.status === 422) {
          TimeRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
